// extracted by mini-css-extract-plugin
export default {"viewItem":"tender-info_viewItem__A0GJP","viewItemValue":"tender-info_viewItemValue__BL+Qy","container":"tender-info_container__pN3Vq"};